const bybcat = {
  "bybcat.page.title": "BYBCAT",
  "bybcat.page.welcome": "¡Bienvenido a BYBCAT!",
  "bybcat.page.instructions_1": "Por favor selecciona tu nombre",
  "bybcat.page.instructions_2": "Elige tu esquema de control y haz el calentamiento. Cuando te sientas listo, comienza la prueba.",
  "bybcat.page.instructions_3": "No hay pruebas programadas.\nPor favor programa una prueba en el Portal para comenzar.",
  "bybcat.page.settings.title": "Configuración de prueba",
  "bybcat.page.completed_title": "Prueba completada",
  "bybcat.page.completed_body": "Tus resultados han sido guardados\n¡Gracias por participar!",
  "bybcat.page.schedule.for_user": "Seleccionar usuarios",
  "bybcat.page.schedule.for_group": "Seleccionar grupos",
  "bybcat.users": "usuarios",
  "bybcat.groups": "grupos",
  "bybcat.search.groups": "Buscar grupos...",
  "bybcat.search_configs": "Buscar pruebas...",
  "bybcat.search_users": "Buscar usuarios...",

  "bybcat.metric.wm": "Memoria de trabajo",
  "bybcat.metric.pr": "Reconocimiento de patrones",
  "bybcat.metric.scanrate": "Frecuencia de escaneo",
  "bybcat.metric.scantiming": "Ritmo de escaneo",
  "bybcat.metric.inhibition": "Inhibición",

  "bybcat.metric.long.wm": "Memoria de trabajo (%)",
  "bybcat.metric.long.pr": "Reconocimiento de patrones (%)",
  "bybcat.metric.long.scanrate": "Velocidad de escaneo (Escaneos/seg)",
  "bybcat.metric.long.scantiming": "Sincronización de escaneo (%)",
  "bybcat.metric.long.inhibition": "Inhibición (%)",

  "bybcat.unit.wm": "%",
  "bybcat.unit.pr": "%",
  "bybcat.unit.scanrate": "Scans/Sec",
  "bybcat.unit.scantiming": "%",
  "bybcat.unit.inhibition": "%",

  // Benchmarks
  "bybcat.benchmark.overallsds": "Todos tus jugadores",
  "bybcat.benchmark.playersds": "Jugador actual",
  "bybcat.benchmark.bybbenchmarksds": "Referencia BYB",

  "bybcat.button.start": "Iniciar",
  "bybcat.label.controls": "Controlador activo",
  "bybcat.controls.left": "Siempre izquierda",
  "bybcat.controls.right": "Siempre derecha",
  "bybcat.controls.dynamic": "Último pulsado",
  "bybcat.button.import_users": "Importar usuarios",
  "bybcat.label.general": "General",
  "bybcat.label.warmup": "Calentamiento",
  "bybcat.label.wm": "Memoria de trabajo",
  "bybcat.label.pr": "Reconocimiento de patrones",
  "bybcat.label.inhibition": "Inhibición",
  "bybcat.label.settings": "Configuración",
  "bybcat.label.settings.test_code": "Código de prueba",
  "bybcat.label.settings.test_code_caption": "El código de prueba decide qué escenarios se usan en la prueba. Use el código recomendado o ingrese su propio código entre 1 y 99999",
  "bybcat.label.settings.slice_length": "Duración del segmento",
  "bybcat.label.settings.slice_count": "Número de segmentos",
  "bybcat.label.settings.min_slice_speed": "Velocidad mínima de segmento",
  "bybcat.label.settings.max_slice_speed": "Velocidad máxima de segmento",
  "bybcat.label.settings.warmup_code": "Código de calentamiento",
  "bybcat.label.settings.warmup_speed": "Velocidad del juego",
  "bybcat.label.settings.warmup_neutral_count": "Cantidad de escenarios neutrales",
  "bybcat.label.settings.warmup_inhibition_count": "Cantidad de pruebas de inhibición",
  "bybcat.label.settings.warmup_pr_count": "Cantidad de pruebas de patrones",
  "bybcat.label.settings.warmup_wm_count": "Cantidad de pruebas de memoria",
  "bybcat.label.settings.wm_count": "Pruebas por segmento",
  "bybcat.label.settings.wm_subject_count": "Estímulos por prueba",
  "bybcat.label.settings.wm_max_incorrect_answers": "Máximo de respuestas incorrectas",
  "bybcat.label.settings.wm_duration": "Duración de la prueba (segundos)",
  "bybcat.label.settings.wm_minimum_game_time": "Tiempo mínimo de juego (segundos)",
  "bybcat.label.settings.pr_count": "Pruebas por segmento",
  "bybcat.label.settings.pr_subject_count": "Estímulos por prueba",
  "bybcat.label.settings.pr_max_incorrect_answers": "Máximo de respuestas incorrectas",
  "bybcat.label.settings.pr_duration": "Duración de la prueba (segundos)",
  "bybcat.label.settings.pr_minimum_game_time": "Tiempo mínimo de juego (segundos)",
  "bybcat.label.settings.inhibition_count": "Pruebas por segmento",
  "bybcat.label.settings.inhibition_duration": "Duración de la prueba (segundos)",

  "bybcat.page.schedule.loading_schedule": "Programando prueba...",
  "bybcat.page.schedule.loading_results": "Cargando resultados...",
  "bybcat.page.schedule.loading_configs": "Cargando pruebas...",
  "bybcat.page.schedule.loading_users": "Cargando usuarios...",

  // Config List Page
  "bybcat.page.configs.title": "Mis pruebas",
  "bybcat.button.create_config": "Crear nueva prueba",
  "bybcat.page.configs.no_configs": "No se encontraron pruebas",

  // User List Page
  "bybcat.page.users.title": "Mis usuarios",
  "bybcat.page.groups.title": "Mis grupos",
  "bybcat.button.create_user": "Crear nuevo usuario",
  "bybcat.dialog.create_user.title": "Crear nuevo usuario",
  "bybcat.dialog.update_user.title": "Editar usuario",
  "bybcat.page.users.no_users": "No se encontraron usuarios",

  // Common Labels
  "label.name": "Nombre",
  "label.email": "Correo electrónico",
  "label.birth_date": "Fecha de nacimiento",
  "button.cancel": "Cancelar",
  "button.create": "Crear",

  // Config Page
  "bybcat.button.edit_config": "Editar",
  "bybcat.label.scheduled_tests": "Pruebas programadas",
  "bybcat.label.completed_tests": "Pruebas completadas",
  "bybcat.label.no_scheduled_tests": "Sin pruebas programadas",
  "bybcat.label.no_completed_tests": "Sin pruebas completadas",
  "bybcat.button.add_users": "Agregar usuarios",

  // Status Labels
  "bybcat.status.scheduled": "Programada",
  "bybcat.status.in_progress": "En progreso",
  "bybcat.status.complete": "Completada",
  "bybcat.status.incomplete": "Incompleta",

  // Config Editor
  "bybcat.editor.title": "Editor de configuración",
  "bybcat.editor.general_settings": "Configuración general",
  "bybcat.editor.test_settings": "Configuración de prueba",
  "bybcat.editor.save": "Guardar cambios",
  "bybcat.editor.cancel": "Cancelar",
  // Config List
  "bybcat.configs.create": "Crear nueva configuración",
  "bybcat.configs.empty": "No se encontraron configuraciones",
  "bybcat.configs.search": "Buscar configuraciones",
  // Common Actions
  "bybcat.action.view": "Ver",
  "bybcat.action.edit": "Editar",
  "bybcat.action.delete": "Eliminar",
  "bybcat.action.schedule": "Programar prueba",
  // Messages
  "bybcat.message.config_saved": "Configuración guardada con éxito",
  "bybcat.message.config_deleted": "Configuración eliminada con éxito",
  "bybcat.message.test_scheduled": "Prueba programada con éxito",
  // Confirmations
  "bybcat.confirm.delete_config": "¿Estás seguro de que deseas eliminar esta configuración?",
  "bybcat.confirm.discard_changes": "¿Estás seguro de que deseas descartar los cambios?",

  // Search
  "bybcat.search.users": "Buscar usuarios...",
  "bybcat.search.no_results": "No se encontraron usuarios",

  "bybcat.tooltip.cannot_edit_config_with_results": "Esta configuración ya tiene resultados y no se puede editar.",

  // Delete Result
  "bybcat.confirm.delete_result.title": "Eliminar prueba programada",
  "bybcat.confirm.delete_result.message": "¿Estás seguro de que deseas eliminar esta prueba programada? Esta acción no se puede deshacer.",
  "button.delete": "Eliminar",
};

export { bybcat };
